import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {applicationHistory} from '../../../common/application-history';
import {clearUploadItems, restartUpload} from '../../actions/upload-actions';
import {setAlbumViewMode, setUploadViewMode} from '../../../snapfish/actions/snapfish-actions';
import {clearUploadsList} from '../../../uploadController/actions/uploadController-actions';

import Button from '../../../common/components/button';
import '../../style/upload.scss';

class FileUploadCompleteContent extends PureComponent {
	constructor(props) {
		super(props);

		this.goToAlbum = this.goToAlbum.bind(this);
		this.uploadMore = this.uploadMore.bind(this);
		this.gotoShop = this.gotoShop.bind(this);
		this.uploadDialogClose = this.uploadDialogClose.bind(this);
	}

	goToAlbum() {
		this.props.clearUploadsList();
		if (this.props.snapfishMode) {
			const { snapfishViewAlbumMode, closeDialog } = this.props;
			closeDialog();
			snapfishViewAlbumMode();
		} else {
			const { currentAlbumId, clearUploads, closeDialog, restartUpload } = this.props;
			closeDialog();
			clearUploads();
			restartUpload();
			applicationHistory.push(`/my/albums`);
		}
	}
 removeAllUploadPreviews(){

	const { completeUploads } = this.props;
	for(let i=0;i<completeUploads.length;i++){

		window.URL.revokeObjectURL(completeUploads[i].preview);
	}
 }
	uploadMore() {
		const { clearUploads, closeDialog, clearUploadsList, restartUpload} = this.props;
		clearUploadsList();
		closeDialog();
		clearUploads();
		restartUpload();

	}

	gotoShop() {
		const { clearUploads, clearUploadsList } = this.props;
		clearUploads();
		clearUploadsList();
		this.removeAllUploadPreviews();
		window.location = `${process.env.REACT_APP_SHOP_URI}/gifts/ssoentrypoint?isLoggedIn=true`;
	}

	uploadDialogClose() {
		const { clearUploads, closeDialog, clearUploadsList, restartUpload } = this.props;
		closeDialog();
		clearUploads();
		clearUploadsList();
		restartUpload();
		this.removeAllUploadPreviews();

	}

	render() {
		const { completeUploads, currentAlbumName } = this.props;

		return (
			<div>
				{/*<h1>Upload Complete</h1>*/}
				<div className="icon-dialog-close" onClick={this.uploadDialogClose} />

				<p>You have successfully added {completeUploads.length} file(s) to:</p>
				<div className="dialog-album-name ellipsis">{`${currentAlbumName}`}</div>
				<p>Your upload will appear shortly.</p>
				<p>What would you like to do next?</p>
				<div className={`btn-dialog-upload-container ${this.props.snapfishMode ? 'snapfish' : ''}`}>
					<Button buttonStyle="secondary" className="btn-dialog-2" buttonLabel="Upload"
							onClick={this.uploadMore}/>
					<Button buttonStyle="secondary" className="btn-dialog-2" buttonLabel="Go To Albums"
							onClick={this.goToAlbum}/>
					{/*<Button className={`btn-dialog-red ${this.props.snapfishMode ? 'hidden' : ''}`} onClick={this.gotoShop} Shop />*/}
				</div>
				{/*<div className={`dialog-app-download ${this.props.snapfishMode ? 'hidden' : ''}`}>*/}
					{/*<br />*/}

					{/*<a href="/app-download">*/}
						{/*<div className="icon-desktop-download" />*/}
						{/*<div className="download-msg">{'Next time, automatically upload from your computer >>'}</div>*/}
					{/*</a>*/}
				{/*</div>*/}
			</div>
		);
	}
}

FileUploadCompleteContent.propTypes = {
	albumId: PropTypes.number,
	albumName: PropTypes.string,
	filesToUpload: PropTypes.object,
	clearUploads: PropTypes.func,
	closeDialog: PropTypes.func,
	snapfishMode: PropTypes.bool,
	snapfishViewAlbumMode: PropTypes.func,
	currentAlbumId: PropTypes.number,
	currentAlbumName: PropTypes.string,
	completeUploads: PropTypes.array,
	clearUploadsList: PropTypes.func,
	restartUpload: PropTypes.func
};

const mapStateToProps = state => {
	return {
		filesToUpload: state.upload.filesToUpload,
		currentAlbumId: state.uploadController.uploadAlbumIdDrop,
		currentAlbumName: state.uploadController.uploadAlbumName,
		completeUploads: state.uploadController.filesComplete
	};
};

const mapDispatchToProps = dispatch => {
	return {
		clearUploads: () => {
			dispatch(clearUploadItems());
		},
		snapfishViewAlbumMode: () => {
			dispatch(setAlbumViewMode());
		},
		snapfishViewUploadMode: () => {
			dispatch(setUploadViewMode());
		},
		clearUploadsList: () => {
			dispatch(clearUploadsList());
		},
		restartUpload: () => {
			dispatch(restartUpload());
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(FileUploadCompleteContent);



// WEBPACK FOOTER //
// ./src/upload/components/dialog/file-upload-complete-content.jsx